import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

const NavLink = (props, { router }) => {
  const className = router.isActive(props.to, true) ? 'active' : ''

  return (
    <li className={className}>
      <Link {...props}>{props.children}</Link>
    </li>
  )
}

NavLink.displayName = 'NavLink'

NavLink.contextTypes = {
  router: PropTypes.object
}

NavLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired // eslint-disable-line
}

export default NavLink



// WEBPACK FOOTER //
// ./src/components/header/nav-link.js